import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormService } from '@app-shared/services/form.service';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzUploadFile, NzUploadModule } from 'ng-zorro-antd/upload';

@Component({
  selector: 'lib-upload-input',
  imports: [
    NzFormModule,
    ReactiveFormsModule,
    CommonModule,
    NzUploadModule,
    NzButtonModule,
    TranslateModule,
    FormlyModule,
    NzIconModule,
  ],
  templateUrl: './upload-input.component.html',
  styleUrl: './upload-input.component.scss',
})
export class UploadInputComponent extends FieldType<FieldTypeConfig> {
  fileList: NzUploadFile[] = [];
  deletedFileName = false;
  totalRecord = 0;

  constructor(
    private cdr: ChangeDetectorRef,
    private formService: FormService,
  ) {
    super();
  }

  get errorState() {
    return this.showError ? 'error' : '';
  }

  get showUploadList():
    | boolean
    | {
        showPreviewIcon?: boolean;
        showRemoveIcon?: boolean;
        showDownloadIcon?: boolean;
      } {
    if (this.to.disabled) {
      return {
        showPreviewIcon: false,
        showDownloadIcon: false,
        showRemoveIcon: false,
      };
    }

    if (this.to['fileName']) {
      return {
        showPreviewIcon: false,
        showDownloadIcon: false,
        showRemoveIcon: true,
      };
    }
    return true;
  }

  beforeUpload = (file: NzUploadFile): boolean => {
    if (this.to['fileName']) {
      this.to['required'] = true;
      delete this.to['fileName'];
    }
    if (!this.to['fileType'].includes(file.type)) {
      this.formControl.setErrors({
        fileType: true,
      });
      this.fileList = [];
      this.formControl.markAsDirty();
      this.formControl.markAsTouched();
      return false;
    }

    if (this.to['showRecords']) {
      const fileObj = file.originFileObj || (file as unknown as File);
      const data = new FormData();
      data.append('file', fileObj);
      this.formService.extractCsv(data).subscribe({
        next: (res) => {
          this.totalRecord = res.data.row_count;
          this.options.formState[this.to['stateRecord']] = res.data.row_count;
          this.formControl.updateValueAndValidity({ emitEvent: false });
          this.cdr.detectChanges();
        },
      });
    }

    this.fileList = this.fileList.concat(file);

    this.formControl.setValue(file);
    this.formControl.markAsDirty();
    this.formControl.markAsTouched();
    return false;
  };
  handleRemove = (file: NzUploadFile): boolean => {
    if (this.to['fileName']) {
      this.to['required'] = true;
      delete this.to['fileName'];
    }
    this.fileList = [];

    this.formControl.setValue(null);
    this.formControl.markAsDirty();
    this.formControl.markAsTouched();
    this.formControl.updateValueAndValidity();

    return true;
  };

  ngOnInit() {
    if (this.to['fileName']) {
      this.fileList = [
        {
          uid: String(Date.now()),
          name: this.to['fileName'],
          status: 'done',
        },
      ];
      this.totalRecord = this.options.formState[this.to['stateRecord']] || 0;
    }

    this.formControl.valueChanges.subscribe((value) => {
      if (value instanceof File) {
        this.fileList = [
          {
            uid: String(Date.now()),
            name: value.name,
            status: 'done',
            originFileObj: value,
          },
        ];
      }
    });
  }
}
